import { RiChatSmile2Line } from "react-icons/ri";
import { AiOutlineShopping } from "react-icons/ai";
import { LuMessageCircleMore } from "react-icons/lu";
import { FaArchive } from "react-icons/fa";
import { FaUserFriends } from "react-icons/fa";


export const ListofItems = [

    {
        item_name: "Chats",
        item_icon: <RiChatSmile2Line />,
    },
    {
        item_name: "Marketplace",
        item_icon: <AiOutlineShopping />,
    },
    {
        item_name: "Message requests",
        item_icon: <LuMessageCircleMore />,
    },
    {
        item_name: "Archive",
        item_icon: <FaArchive />,
    },
    {
        item_name: "Friend requests",
        item_icon: <FaUserFriends />,
    },
]